// @flow

import clsx from 'clsx';
import { Text, View } from 'reshaped';

import { useTranslator } from '@gandi/translate';

import { ProductTile } from './ProductTile';

import type { Type } from './ProductTile';

import styles from './CallToAction.module.css';

const productTypes: Array<Type> = [
  'domain',
  /** `ProductTile` toggles dynamically between 'certificate' and 'acme' for now. */
  'certificate',
  'paas',
  'cloud',
  'mailbox-standalone',
];

export function CallToAction({
  isEmptyPage,
}: {
  isEmptyPage?: boolean,
}): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <View
      as="section"
      gap={isEmptyPage ? 12 : 6}
      className={clsx(styles.root, isEmptyPage && styles.emptyPage)}
    >
      <Text
        as="h3"
        variant="body-1"
        weight="bold"
        align={isEmptyPage ? 'center' : 'start'}
      >
        {__('Continue shopping')}
      </Text>
      <div className={styles.products}>
        {productTypes.map(productType => (
          <ProductTile key={productType} type={productType} />
        ))}
      </div>
    </View>
  );
}
